var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2631 11.2754C13.2551 10.4233 12.6771 9.17798 12.6771 7.85864V6C12.6771 3.65405 10.9344 1.71204 8.67712 1.38672V0.666626C8.67712 0.297974 8.37842 0 8.01038 0C7.64246 0 7.34375 0.297974 7.34375 0.666626V1.38672C5.08569 1.71204 3.34375 3.65405 3.34375 6V7.85864C3.34375 9.17798 2.76575 10.4233 1.75171 11.2806C1.49243 11.5027 1.34375 11.8253 1.34375 12.1666C1.34375 12.8101 1.86707 13.3334 2.51038 13.3334H13.5104C14.1538 13.3334 14.6771 12.8101 14.6771 12.1666C14.6771 11.8253 14.5284 11.5027 14.2631 11.2754Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01038 16C9.21777 16 10.2278 15.1393 10.4597 14H5.56104C5.79309 15.1393 6.8031 16 8.01038 16Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellBold);
export default __webpack_public_path__ + "static/media/bellBold.c1625933.svg";
export { ForwardRef as ReactComponent };